import { render, staticRenderFns } from "./statsContainer.vue?vue&type=template&id=a1b988d2&"
import script from "./statsContainer.vue?vue&type=script&lang=js&"
export * from "./statsContainer.vue?vue&type=script&lang=js&"
import style0 from "./statsContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports